import {
  Button,
  Flex,
  Table,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { getChainNameFromChainId } from "configs/chain";
import { getScreenBlockFromKey } from "configs/screenBlock";
import { useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { subAddress } from "utils/helpers";
import ModalAddDexviewscore from "./ModalAddDexviewscore";
import ModalRemoveDexviewscore from "./ModalRemoveDexviewscore";

const columns = [
  {
    Header: "Address",
    accessor: "address",
  },
  {
    Header: "ChainId",
    accessor: "chainId",
  },
  {
    Header: "Token",
    accessor: "token",
  },
  {
    Header: "Information",
    accessor: "information",
  },
  {
    Header: "Transaction",
    accessor: "transaction",
  },
  {
    Header: "Holder",
    accessor: "holder",
  },
  {
    Header: "LpLock",
    accessor: "lpLock",
  },
  {
    Header: "Kyc",
    accessor: "kyc",
  },
  {
    Header: "Updated By",
    accessor: "updatedBy",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Avg",
    accessor: "avg",
  },
  {
    Header: "Update At",
    accessor: "updateAt",
  },
  {
    Header: "Action",
    accessor: "_id",
  },
];

interface IProps {
  tableData: any;
}
export default function DexviewscoreTable({ tableData }: IProps) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const toast = useToast();
  const {
    isOpen: isOpenRemove,
    onOpen: onOpenRemove,
    onClose: onCloseRemove,
  } = useDisclosure();
  const {
    isOpen: isOpenUpdate,
    onOpen: onOpenUpdate,
    onClose: onCloseUpdate,
  } = useDisclosure();

  const [rowObj, setRowObj] = useState(null);

  const tableInstance = useTable(
    {
      columns,
      data: tableData || [],
      initialState: {
        pageSize: 10,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const bgColor = useColorModeValue("white", "navy.800");

  const handleOpenRemove = (row: any) => {
    setRowObj(row);
    onOpenRemove();
  };

  const handleUpdate = (row: any) => {
    setRowObj(row);
    onOpenUpdate();
  };

  const handleCopy = (address: string | undefined) => {
    if (!address) return;
    navigator.clipboard.writeText(address);
    toast({
      title: "Copy successfully",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  return (
    <>
      <ModalRemoveDexviewscore
        isOpen={isOpenRemove}
        onClose={onCloseRemove}
        currentId={rowObj?._id}
      />
      <ModalAddDexviewscore
        isOpen={isOpenUpdate}
        onClose={onCloseUpdate}
        currentId={rowObj}
      />

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                  // pos={{
                  //   base: column?.Header === 'Action' ? 'sticky' : 'unset',
                  // }}
                  // zIndex={{
                  //   base: column?.Header === 'Action' ? 'banner' : 'unset',
                  // }}
                  // right={{
                  //   base: column?.Header === 'Action' ? '0px' : 'unset',
                  // }}
                  bgColor={bgColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          color={textColor}
          fontWeight={"bold"}
          fontSize={"sm"}
        >
          {page?.map((row: any, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                <Td
                  onClick={() => handleCopy(row?.original?.address)}
                  cursor="copy"
                >
                  {subAddress(row?.original?.address)}
                </Td>
                <Td>
                  {getChainNameFromChainId(Number(row?.original?.chainId))}
                </Td>
                <Td>{row?.original?.token}</Td>
                <Td>{row?.original?.information}</Td>
                <Td>{row?.original?.transaction}</Td>
                <Td>{row?.original?.holder}</Td>
                <Td>{row?.original?.lpLock}</Td>
                <Td>{row?.original?.kyc}</Td>
                <Td>{row?.original?.updatedBy}</Td>
                <Td>{row?.original?.status === 1 ? "ACTIVE" : "INACTIVE"}</Td>
                <Td>{row?.original?.avg}</Td>
                <Td>
                  {row?.original?.updateAt
                    ? new Date(row?.original?.updateAt).toLocaleDateString()
                    : null}
                </Td>
                <Td>
                  <Button
                    colorScheme="blue"
                    mr="5px"
                    mt="5px"
                    size="sm"
                    onClick={() => handleUpdate(row?.original)}
                  >
                    Update
                  </Button>
                  <Button
                    colorScheme="red"
                    mr="5px"
                    mt="5px"
                    size="sm"
                    onClick={() => handleOpenRemove(row?.original)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </>
  );
}
